import { shortlist } from "./shortlist";
import "./shortlist.scss";
export { shortlist };
if (window) window.shortlist = shortlist;
